import Tooltip from "@mui/material/Tooltip";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useAppDialog } from "../../store/app-dialog";
import { Box, Fab, styled } from "@mui/material";
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import l10n from "../../lib/l10n";
import { useCropperAction } from "@src/v3.0.0/store/cropper/cropper-actions";
import ActionResetDialog from "./ActionResetDialog";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";

const CommandsIndicator = styled(Box)`
  &::before {
    content: "${({ times }) => times}";
    display: block;
    line-height: 16px;
    font-size: 0.65em;
  }
  line-height: 16px;
  color: #fff;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: ${({ theme }) => theme.palette.primary.main};
`;

const CommandFab = styled(Fab)`
  position: relative;
`;

function ActionsTool() {
  const { dispatch: dispatchCropperAction } = useCropperAction();
  const { closeDialog, invokeDialog } = useAppDialog();
  const { undo, redo, redoPreset, undoPreset } = useCropperStore();

  const onClickResetCropper = async (e) => {
    try {
      await invokeDialog(ActionResetDialog, { title: 'Reimpostare la stampa?', type: useAppDialog.WARN });
    } catch(e) {
      return;
    }

    closeDialog();
    dispatchCropperAction({ zeroAll: null });
  };

  return (
    <>
      {l10n.wppr_cjs_ctrl_history_active === "yes" && (
        <>
          <Tooltip title="Indietro" placement="top">
            <span>
              <CommandFab disabled={undo.length <= 0} onClick={undoPreset}>
                {undo.length > 0 && <CommandsIndicator times={undo.length} />}
                <UndoIcon />
              </CommandFab>
            </span>
          </Tooltip>
          <Tooltip title="Avanti" placement="top">
            <span>
              <CommandFab disabled={redo.length <= 0} onClick={redoPreset}>
                {redo.length > 0 && <CommandsIndicator times={redo.length} />}
                <RedoIcon />
              </CommandFab>
            </span>
          </Tooltip>
        </>
      )}
      {l10n.wppr_cjs_ctrl_reset_active === "yes" &&(
        <Tooltip title="Da capo" placement="top">
          <Fab onClick={onClickResetCropper}>
            <RestartAltIcon />
          </Fab>
        </Tooltip>
      )}
    </>
  );
};

export default ActionsTool;